document.addEventListener("DOMContentLoaded", function () {
    // nice-select-2 init
    var lang = document.documentElement.lang;
    var selectElements = document.querySelectorAll('select.nice-select');
    selectElements.forEach(function (selectElement) {
        if (selectElement) {
            if (lang === 'es-MX') {
              const esSelect = NiceSelect.bind(selectElement, {
                    searchable: false,
                    placeholder: '-- Seleccione un servicio',
                    searchtext: 'Buscar...',
                    selectedtext: 'seleccionado'
                });
              document.addEventListener('wpcf7mailsent', function (event) {
                esSelect.update();
              }, false);
            } else {
              const enSelect = NiceSelect.bind(selectElement, {
                    searchable: false,
                    placeholder: '-- Select a service',
                    searchtext: 'Search...',
                    selectedtext: 'selected'
                });
              document.addEventListener('wpcf7mailsent', function (event) {
                enSelect.update();
              }, false);
            }
        }
    });

    // this piece of code makes nice-select-2 validation
    let selects = document.querySelectorAll('.nice-select');
    function handleClassChange(niceSelect) {
        setTimeout(function () {
            if (niceSelect.classList.contains('open')) {
                var parent = niceSelect.closest('.wpcf7-form-control-wrap');
                if (parent && parent.classList.contains('fv-invalid-field-wrapper')) {
                    parent.classList.remove('fv-invalid-field-wrapper');
                }
                const previousElement = niceSelect.previousElementSibling;
                if (previousElement && previousElement.classList.contains('fv-err')) {
                    previousElement.remove();
                }
            }
        }, 100);
    }
    let observer = new MutationObserver(function (mutationsList) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                handleClassChange(mutation.target);
            }
        }
    });
    selects.forEach(function (niceSelect) {
        observer.observe(niceSelect, { attributes: true });
    });
});
